module.exports = __webpack_public_path__ + "static/media/c1do1-logo-new.e8a87301.svg";